export const replaceSpacesAndCapitalise = (str: string) => {
  const strWithoutSpaces = str.replaceAll(' ', '_').trim();

  return strWithoutSpaces.toUpperCase();
};
